import React, { useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const MU_LOGO_URL = 'https://customer-assets.emergentagent.com/job_career-heat-map/artifacts/8zniuor4_MU%20Logo.png';

export const AdminLogin = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username || !password) { setError('Please enter both username and password.'); return; }
    setLoading(true);
    setError('');
    try {
      const res = await axios.post(`${API}/admin/login`, { username, password });
      localStorage.setItem('mu_admin_token', res.data.token);
      localStorage.setItem('mu_admin_user', res.data.username);
      window.location.href = '/admin/dashboard';
    } catch (err) {
      setError(err.response?.data?.detail || 'Login failed. Check your credentials.');
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = {
    width: '100%', backgroundColor: '#fafafa',
    border: '1.5px solid rgba(0,0,0,0.12)', borderRadius: '10px',
    padding: '12px 16px', fontFamily: 'DM Sans, sans-serif',
    fontSize: '14px', color: '#111111', outline: 'none',
    transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
  };

  return (
    <div style={{
      minHeight: '100vh', backgroundColor: '#fafafa',
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      padding: '24px',
      background: 'radial-gradient(ellipse 80% 40% at 50% 0%, #FFF7E6 0%, #fafafa 50%)',
    }}>
      <div style={{ marginBottom: '32px', textAlign: 'center' }}>
        <img src={MU_LOGO_URL} alt="Masters' Union" style={{ height: '32px', objectFit: 'contain', marginBottom: '8px', display: 'block', margin: '0 auto 8px' }} />
        <p style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '11px', color: 'rgba(0,0,0,0.38)', letterSpacing: '0.12em', textTransform: 'uppercase' }}>Admin Portal</p>
      </div>

      <div style={{
        backgroundColor: '#ffffff', border: '1px solid rgba(0,0,0,0.08)',
        borderRadius: '16px', padding: '32px 28px',
        width: '100%', maxWidth: '400px',
        boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
      }}>
        <h2 style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '20px', fontWeight: 700, color: '#111111', marginBottom: '6px' }}>Sign in</h2>
        <p style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '14px', color: 'rgba(0,0,0,0.44)', marginBottom: '24px' }}>Access the submissions dashboard</p>

        {error && (
          <div style={{
            backgroundColor: 'rgba(217,64,64,0.06)', border: '1px solid rgba(217,64,64,0.20)',
            borderRadius: '8px', padding: '10px 14px', marginBottom: '16px',
            fontFamily: 'DM Sans, sans-serif', fontSize: '13px', color: '#D94040',
          }}>{error}</div>
        )}

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
          <div>
            <label style={{ display: 'block', fontFamily: 'DM Sans', fontSize: '11px', fontWeight: 600, color: 'rgba(0,0,0,0.50)', marginBottom: '6px', letterSpacing: '0.06em', textTransform: 'uppercase' }}>Username</label>
            <input type="text" value={username} onChange={e => setUsername(e.target.value)}
              placeholder="admin" autoComplete="username" style={inputStyle}
              onFocus={e => { e.target.style.borderColor = '#E8A020'; e.target.style.boxShadow = '0 0 0 3px rgba(232,160,32,0.10)'; }}
              onBlur={e => { e.target.style.borderColor = 'rgba(0,0,0,0.12)'; e.target.style.boxShadow = 'none'; }}
            />
          </div>
          <div>
            <label style={{ display: 'block', fontFamily: 'DM Sans', fontSize: '11px', fontWeight: 600, color: 'rgba(0,0,0,0.50)', marginBottom: '6px', letterSpacing: '0.06em', textTransform: 'uppercase' }}>Password</label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)}
              placeholder="••••••••" autoComplete="current-password" style={inputStyle}
              onFocus={e => { e.target.style.borderColor = '#E8A020'; e.target.style.boxShadow = '0 0 0 3px rgba(232,160,32,0.10)'; }}
              onBlur={e => { e.target.style.borderColor = 'rgba(0,0,0,0.12)'; e.target.style.boxShadow = 'none'; }}
            />
          </div>
          <button type="submit" disabled={loading} style={{
            width: '100%', padding: '13px 24px',
            backgroundColor: '#E8A020', border: 'none', borderRadius: '9999px',
            cursor: loading ? 'not-allowed' : 'pointer',
            fontFamily: 'DM Sans, sans-serif', fontSize: '15px', fontWeight: 700, color: '#ffffff',
            opacity: loading ? 0.7 : 1, marginTop: '4px',
            transition: 'opacity 0.2s ease, transform 0.15s ease',
          }}
            onMouseEnter={e => !loading && (e.currentTarget.style.transform = 'scale(1.01)')}
            onMouseLeave={e => (e.currentTarget.style.transform = 'scale(1)')}
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
      </div>

      <a href="/" style={{ marginTop: '20px', fontFamily: 'DM Sans', fontSize: '13px', color: 'rgba(0,0,0,0.40)', textDecoration: 'none' }}>
        ← Back to career tool
      </a>
    </div>
  );
};
